import AppConstants from '../config/app.constants';

let HoldLocationService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/hold-location`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let release = (supId, locationId, comment, branchId) => {
        return $http
            .post(AppConstants.api + `/hold-location/release`, {
                supervisorId: supId,
                locationId,
                comment,
                branchId
            })
            .then((res) => {
                return res.data
            });
    }

    let holdLocationCount = (branchId) => {
        return $http
            .get(AppConstants.api + `/hold-location/hold-location-count`, {
                params: {
                    branchId
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let getHoldLocation = (searchText, branchId, status, limit, offset) => {
        return $http 
            .get(AppConstants.api + `/hold-location/get-hold-location`, {
                    params: {
                        searchText, 
                        branchId, 
                        status, 
                        limit, 
                        offset
                    }
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        release,
        holdLocationCount,
        getHoldLocation
    };
};

HoldLocationService.$inject = ['$http', '$q']

export default HoldLocationService;


// WEBPACK FOOTER //
// ./client/app/services/hold-location.service.js